import { type Event } from '@pubnub/chat';
import { useEffect } from 'react';
import { ChannelType } from '@avanta/shared/constants/chat';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';
import { useChatStore } from '@avanta/shared/stores/chat/index';

export const useNewConversationListener = (): void => {
  const chat = useChatStore(state => state.chat);
  const isInitialized = useChatStore(state => state.isInitialized);

  useEffect(() => {
    if (!chat || !isInitialized) return;

    const handleInvite = async (event: Event<'invite'>): Promise<void> => {
      const { channelType, channelId } = event.payload;

      if (channelType !== ChannelType.DIRECT) return;

      const { conversations, addConversation } = useConversationsStore.getState();

      if (conversations.has(channelId)) return;

      const channel = await chat.getChannel(channelId);
      if (!channel) return;

      const { members } = await channel.getMembers();
      const otherUser = members.find(member => member.user?.id !== chat.currentUser.id)?.user;
      if (!otherUser) return;

      addConversation({ channel, otherUser, unreadCount: 0 });
    };

    const unsubscribe = chat.listenForEvents({
      type: 'invite',
      channel: chat.currentUser.id,
      callback: (event: Event<'invite'>) => {
        void handleInvite(event);
      },
    });

    return (): void => {
      unsubscribe();
    };
  }, [chat, isInitialized]);
};
